/**
 * Main vendor dashboard content
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';

import PageTitle from '../ui/PageTitle';

import VendorDashboardSummary from './VendorDashboardSummary';
import VendorDashboardTopResellers from './VendorDashboardTopResellers';
import DashboardVendorProblems from './DashboardVendorProblems';

const styleSheet = theme => ({
  root: {
    width: '100%',
  }
});

class VendorDashboard extends Component {
  state = {
  };

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {

    return (
      <div >
        <PageTitle title="Dashboard" subtitle="Quick view of your partner program" />

        <DashboardVendorProblems auth={this.props.auth} history={this.props.history} />

        <VendorDashboardSummary auth={this.props.auth} registered={0} />
        <VendorDashboardSummary auth={this.props.auth} registered={1} />
        <VendorDashboardTopResellers auth={this.props.auth} history={this.props.history} />
      </div>
    );
  }
}

export default withStyles(styleSheet)(VendorDashboard);
